var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "users-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M20.1663 19.25V17.4167C20.1663 15.7081 18.9978 14.2726 17.4163 13.8655M14.208 3.01653C15.5518 3.56047 16.4997 4.87787 16.4997 6.41667C16.4997 7.95547 15.5518 9.27287 14.208 9.8168M15.583 19.25C15.583 17.5415 15.583 16.6873 15.3039 16.0135C14.9318 15.1151 14.218 14.4013 13.3195 14.0291C12.6457 13.75 11.7915 13.75 10.083 13.75H7.33301C5.62456 13.75 4.77033 13.75 4.0965 14.0291C3.19807 14.4013 2.48426 15.1151 2.11212 16.0135C1.83301 16.6873 1.83301 17.5415 1.83301 19.25M12.3747 6.41667C12.3747 8.44171 10.7331 10.0833 8.70801 10.0833C6.68296 10.0833 5.04134 8.44171 5.04134 6.41667C5.04134 4.39162 6.68296 2.75 8.70801 2.75C10.7331 2.75 12.3747 4.39162 12.3747 6.41667Z",
    stroke: "#FFE600",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalUsers);
export default __webpack_public_path__ + "static/media/total_users.d61b0c6f2c88a54af7514731f99bd574.svg";
export { ForwardRef as ReactComponent };